var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.778564,
    width: 25,
    height: 25,
    rx: 6,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.954 25C24.1424 25 25.9164 23.226 25.9164 21.0376H22.9017L21.2116 19.3219L19.6511 21.0376H9.7083V13.0392H6.49752L10.4763 4.02778H14.3161L15.6887 7.11601V4.02778H20.4436L21.2688 6.35621L22.1021 4.02778H25.9164C25.9164 1.8033 24.1131 0 21.8887 0H5.77856C3.01714 0 0.778564 2.23858 0.778564 5V20C0.778564 22.7614 3.01714 25 5.77856 25H21.954ZM23.4083 20.0327H25.9164L22.4616 16.5114L25.9164 13.031H23.4491L21.2606 15.2778L19.2344 13.0392H16.7263L20.0269 16.5359L16.7263 20.0327H19.1609L21.2197 17.7778L23.4083 20.0327ZM23.9965 16.5196L25.9164 18.5621V14.4935L23.9965 16.5196ZM12.674 18.415V17.3284H16.6201V15.7516H12.674V14.665H16.7181V13.0474H10.7622V20.0408H16.7181V18.4232H12.674V18.415ZM24.0292 12.0261H25.9164V5.03268H22.9753L21.2688 9.38726L19.7083 5.03268H16.7181V12.0261H18.6054V7.12418L20.4027 12.018H22.0858L24.021 7.10784V12.0261H24.0292ZM14.5776 12.0261H16.7263L13.638 5.03268H11.1789L8.09066 12.0261H10.1903L10.7704 10.6291H13.9894L14.5776 12.0261ZM13.3276 9.06046H11.4322L12.3799 6.77288L13.3276 9.06046Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexIcon);
export default __webpack_public_path__ + "static/media/amex-icon.b1e7301d629a5b26aa5d09a086dfdf9e.svg";
export { ForwardRef as ReactComponent };